module.exports = __webpack_public_path__ + "img/index_icon_6.576f1788.png";